<div>
  <h6 class="odx-title-6" i18n="@@floorplan.selectionMode.title">Auswahlmodus</h6>
  <form odxForm [formGroup]="selectionModeForm">
    <odx-toggle-button-group formControlName="selectionMode">
      <odx-toggle-button [value]="FloorplanSelectionMode.SINGLE">
        {{ FloorplanSelectionMode.SINGLE | localizeFloorplanSelectionMode }}
      </odx-toggle-button>
      <odx-toggle-button [value]="FloorplanSelectionMode.MULTI">{{
        FloorplanSelectionMode.MULTI | localizeFloorplanSelectionMode
      }}</odx-toggle-button>
    </odx-toggle-button-group>
  </form>
  <hr />
</div>
